export const GET_REQUIREMENTS = 'form-requirements/GET_REQUIREMENTS';
export const GET_SPARSE_REQUIREMENTS = 'form-requirements/GET_SPARSE_REQUIREMENTS';
